<template>
  <div class="calculator-no-results">
    <QIcon color="primary" class="q-mb-sm" :name="closeIcon" size="3rem" />

    <h4 class="font-nunito text-primary">No results found.</h4>

    <p class="no-results-text">The selections made did not return any results. Please adjust the filter choices and try again.</p>

    <CalculatorButton color="primary" rounded label="Reset Filter" outlined @click="$emit('reset')" />
  </div>
</template>

<script>
import { QIcon } from 'eclipx.ui';
import CalculatorButton from '../CalculatorButton';
import { evaCloseCircleOutline } from '@quasar/extras/eva-icons';

export default {
  name: 'NoResult',
  components: { CalculatorButton, QIcon },
  props: {},
  data() {
    return {
      closeIcon: null
    };
  },
  created() {
    this.closeIcon = evaCloseCircleOutline;
  },
  computed: {},
  methods: {}
};
</script>
